import { render } from "./MaterialDialog.vue?vue&type=template&id=7c23d60d&ts=true"
import script from "./MaterialDialog.vue?vue&type=script&lang=ts"
export * from "./MaterialDialog.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__